import { render, staticRenderFns } from "./knowledgeDocList.vue?vue&type=template&id=e1c00652&scoped=true"
import script from "./knowledgeDocList.vue?vue&type=script&lang=js"
export * from "./knowledgeDocList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeDocList.vue?vue&type=style&index=0&id=e1c00652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c00652",
  null
  
)

export default component.exports